import React, { useEffect } from "react";

// Style
import './NotFound.scss';

// components
import Button from "components/UiKit/Button";

// Navigation
import { useNavigate } from "react-router-dom";

// Lib
import Cookies from "js-cookie";
import { amplitudeInstance, events } from "constans/cookie";

export const NotFound: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const isCookie = Cookies.get("cookieName");

    if (isCookie) {
      amplitudeInstance.logEvent(events.not_found);
    }

    document.body.classList.add("wrapper-not-found");

    return () => document.body.classList.remove("wrapper-not-found");
  }, []);

  const handlerChange = () => {
    navigate("/");
  };

  return (
    <div className="not-found flex flex-ai-center flex-jc-center flex-direction-column">
      <div className="not-found__bg" />
      <h1>
        404
      </h1>
      <h4>
        Service Unavailable
      </h4>
      <p className="not-found__p">
        We are very sorry for the inconvenience. It looks like you're trying to<br /> access an unavailable page for
        now.
      </p>
      <div className="not-found__wrapper-btn flex flex-ai-center">
        <Button
          variable="info"
          label="Go Back"
          typePadding="small"
          onPress={handlerChange}
        />
      </div>
    </div>
  );
};

export default NotFound;